import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Icon, { ICONS, COLORS } from '../../../../../general-ui/icon';
import classNames from 'classnames';
import { TypographyItem } from '../../../../../general-ui/typography-item/typography-item';
import { TemplateClassNames } from '../../../../../../types/template-layouts';
import { SponsorCallToAction } from '../../../../../live-event/modules/sponsors/sponsor-card';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Sponsor(props: any): JSX.Element {
	const { attributes, listeners, setNodeRef, transform } = useSortable({
		id: props.id,
	});

	const {
		sponsor,
		editSponsor,
		checkDeleteSponsor,
		template,
		handleScroll,
		language
	} = props;

	const style = {
		transform: CSS.Transform.toString(transform),
		transition: 'none',
	};

	return (
		<li
			ref={setNodeRef}
			style={style}
			{...attributes}
			{...listeners}
			className="sponsor-card"
		>
			<div className="sponsor-card-container">
				<div className="sponsor-card-image">
					<img src={sponsor.image} alt={sponsor?.name} />
				</div>
				<TypographyItem
					className={classNames('sponsor-card-title stable', {
						'evt-heading-3': template === TemplateClassNames.Apollo,
						'evt-heading-4': template !== TemplateClassNames.Apollo,
					})}
					tagName="h3"
				>
					{sponsor.name}
				</TypographyItem>
				<TypographyItem className={classNames('evt-body-text-2 sponsor-card-description')}>
					{sponsor.description[language] ?? sponsor.description.base}
				</TypographyItem>
				{
					sponsor.enable_cta && (
						<SponsorCallToAction
							call_to_action={sponsor.call_to_action}
							className="sponsor-card-call-to-action"
							language={language}
							handleScroll={handleScroll}
							cta_isOn={sponsor.enable_cta}
						/>
					)
				}
			</div>
			<div className="edit-actions">
				<button className="round edit-button" onClick={editSponsor(sponsor)}>
					<Icon name={ICONS.EDIT} size={12} color={COLORS.WHITE} />
				</button>
				<button className="round edit-button" onClick={checkDeleteSponsor(sponsor)}>
					<Icon name={ICONS.TRASH} size={12} color={COLORS.WHITE} />
				</button>
			</div>
		</li>
	);
}
